import { FontFamilyPanel } from 'markerjs2';
import { Subscription } from 'rxjs';
import { DropdownComponent } from '../../../../../Common/Forms/components/Dropdown/dropdown.component';


export class ChartAnnotationFontFamilyPanel extends FontFamilyPanel {

    fontFamilyPanel: DropdownComponent;
    currFontFamily: string;
    subscription: Subscription;

    constructor(
        title: string,
        fonts: string[],
        currentFont?: string,
        icon?: string,
        component?: DropdownComponent
    ) {
        super(
            title,
            fonts,
            currentFont,
            icon
        );
        this.fontFamilyPanel = component;
        this.currFontFamily = currentFont;
    }

    getUi(): HTMLDivElement {
        this.fontFamilyPanel.writeValue(this.currFontFamily);
        const container = this.fontFamilyPanel.container;
        if (container) {
            const dropdownElement = container.children[0] as HTMLElement;
            if (dropdownElement) {
                dropdownElement.style.width = '200px';
                dropdownElement.style.margin = 'auto';
            }
        }

        this.subscription = this.fontFamilyPanel.change.subscribe(x => {
            if (this.onFontChanged) {
                this.currFontFamily = x.value;
                this.onFontChanged(x.value);
            }
        });
        return container;
    }
}
